<cam-badge type="default" [value]="this.getTranslate() | translate"></cam-badge>
